// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 184) return "static/chunks/184-af5073d326d11908.js";
	if (chunkId === 36) return "static/chunks/36-6d1e2c2543dd7337.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"316":"825dde126f151980","735":"4be63a2b82bd420c","898":"bff41c9f2da433c4"}[chunkId] + ".js";
};